var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReduxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_301_8805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.9329,
    y: 36.4058,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#1D1F23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4329,
    y: 36.9058,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.327 144.834C154.017 144.452 156.817 141.271 156.689 137.453C156.562 133.636 153.381 130.581 149.563 130.581H149.309C145.363 130.709 142.309 134.017 142.437 137.962C142.564 139.871 143.327 141.525 144.473 142.671C140.146 151.197 133.529 157.433 123.603 162.65C116.859 166.214 109.86 167.486 102.861 166.596C97.1344 165.832 92.6805 163.287 89.8805 159.087C85.8087 152.852 85.427 146.107 88.863 139.362C91.2809 134.526 95.0981 130.963 97.5161 129.181C97.0071 127.527 96.2434 124.727 95.8618 122.691C77.4098 136.053 79.3188 154.124 84.918 162.65C89.1173 169.014 97.6434 172.959 107.06 172.959C109.605 172.959 112.15 172.704 114.695 172.068C130.984 168.886 143.328 159.214 150.327 144.834ZM172.724 129.054C163.052 117.728 148.8 111.493 132.511 111.493H130.475C129.33 109.202 126.912 107.675 124.24 107.675H123.985C120.04 107.802 116.986 111.111 117.113 115.056C117.241 118.873 120.422 121.928 124.24 121.928H124.494C127.293 121.8 129.711 120.019 130.729 117.601H133.02C142.692 117.601 151.854 120.4 160.126 125.873C166.488 130.072 171.069 135.545 173.614 142.162C175.777 147.507 175.65 152.724 173.36 157.178C169.797 163.923 163.816 167.614 155.926 167.614C150.836 167.614 146 166.086 143.455 164.941C142.055 166.214 139.51 168.25 137.728 169.523C143.201 172.068 148.8 173.468 154.144 173.468C166.361 173.468 175.396 166.723 178.832 159.978C182.522 152.597 182.267 139.871 172.724 129.054ZM108.078 146.997C108.206 150.815 111.387 153.869 115.204 153.869H115.459C119.404 153.742 122.458 150.433 122.331 146.488C122.204 142.67 119.022 139.616 115.204 139.616H114.95C114.695 139.616 114.313 139.616 114.059 139.743C108.842 131.09 106.679 121.673 107.442 111.492C107.951 103.857 110.496 97.239 114.95 91.7668C118.64 87.0582 125.767 84.7676 130.602 84.6406C144.091 84.3859 149.817 101.184 150.199 107.929C151.854 108.311 154.653 109.202 156.562 109.838C155.035 89.2223 142.309 78.5324 130.093 78.5324C118.64 78.5324 108.078 86.8043 103.879 99.0211C98.0251 115.31 101.843 130.963 108.969 143.307C108.333 144.198 107.951 145.598 108.078 146.998V146.997Z",
    fill: "#764ABC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_301_8805",
    x: 0.932861,
    y: 0.405762,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_8805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_8805",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduxIcon);
export default __webpack_public_path__ + "static/media/redux_icon.979012cf1729c04f1876592689c7f08f.svg";
export { ForwardRef as ReactComponent };